/**
 * @tebhos/schema — Zod şemaları (Message, Profile, Channel, Server).
 *
 * İskelet: Şemalar ileride runtime validation için kullanılacak
 * (API request body, WS event payload, vb.). Şu an sadece wire-up testi
 * için minimal placeholder şemalar duruyor.
 */

import { z } from "zod";

export const ProfileSchema = z.object({
  id: z.string(),
  userId: z.string().optional(),
  name: z.string(),
  imageUrl: z.string(),
  email: z.string(),
  bio: z.string().nullable().optional(),
  customStatus: z.string().nullable().optional(),
  bannerColor: z.string().nullable().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export const ChannelTypeSchema = z.enum(["TEXT", "AUDIO", "VIDEO"]);

export const ChannelSchema = z.object({
  id: z.string(),
  name: z.string(),
  type: ChannelTypeSchema,
  locked: z.boolean().optional(),
  order: z.number().optional(),
  category: z.string().optional(),
  serverId: z.string(),
  topic: z.string().nullable().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

export const MessageSchema = z.object({
  id: z.string(),
  content: z.string(),
  fileUrl: z.string().nullable().optional(),
  memberId: z.string(),
  channelId: z.string(),
  deleted: z.boolean(),
  pinned: z.boolean().optional(),
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const ServerSchema = z.object({
  id: z.string(),
  name: z.string(),
  imageUrl: z.string(),
  inviteCode: z.string(),
  profileId: z.string(),
  description: z.string().nullable().optional(),
  banner: z.string().nullable().optional(),
  createdAt: z.string().optional(),
  updatedAt: z.string().optional(),
});

// ---------------------------------------------------------------------------
// Protobuf codec katmanı (Kaynak paritesi). read_state ve user-preferences
// payload'ları FE-uçları arası deterministik binary'e sıkıştırılıp opak base64
// blob olarak JSON gövdesine gömülür. Wire transport (gateway/backend) JSON kalır
// ve blob'dan habersizdir. Üretilen tipler: src/gen/tebhos/**  (buf generate).
// ---------------------------------------------------------------------------
export {
  EMPTY_READ_STATE_PROTO,
  ReadStateProtoDecodeError,
  decodeReadStateProto,
  decodeReadStateProtoBundle,
  encodeReadStateProto,
  encodeReadStateProtoNative,
} from "./domains/read_state/ReadStateProtoCodec";

// SyncedPreferences codec — HAZIR ama canlı bağlanmadı (dalga-2, ertelendi).
export {
  EMPTY_SYNCED_PREFERENCES_ENCODED,
  SYNCED_PREFERENCES_MAX_BYTES,
  SYNCED_PREFERENCES_MAX_ENCODED_LENGTH,
  SyncedPreferencesDecodeError,
  SyncedPreferencesSchema,
  createEmptySyncedPreferences,
  decodeSyncedPreferences,
  decodeSyncedPreferencesLenient,
  encodeSyncedPreferences,
  encodedSyncedPreferencesByteLength,
  isEmptySyncedPreferencesEncoded,
  isValidSyncedPreferencesEncoding,
  syncedPreferencesToJson,
} from "./domains/user/SyncedPreferencesCodec";
export type { SyncedPreferences } from "./domains/user/SyncedPreferencesCodec";
